import { Client } from 'types';
import { ClientActions } from 'types/store/actions/clients';
import { ClientActionTypes } from 'types/store/actions/constants';
import Pagination from 'sources/sourceTypes/Pagination';

export const listSuccess = (payload: Pagination<Client>): ClientActions => ({
  type: ClientActionTypes.LIST_SUCCESS,
  payload,
});

export const listAllSuccess = (records: Array<Client>): ClientActions => ({
  type: ClientActionTypes.LIST_ALL_SUCCESS,
  payload: { records },
});

export const reset = (): ClientActions => ({
  type: ClientActionTypes.RESET,
});

export const setLoading = (isLoading: boolean): ClientActions => ({
  type: ClientActionTypes.SET_LOADING,
  payload: { isLoading },
});
